import { Reducer } from "redux";
import { GlobalReducer } from "../app";
import { initialResponseState, IResponseState } from "../state";
import { LoginActions, LoginTypes } from "./login.type";

export const LoginReducer: Reducer<IResponseState, LoginActions> = (
  state = initialResponseState,
  action: LoginActions
) => GlobalReducer(state, action, LoginTypes.LOGIN.toString());
